module.exports = __webpack_public_path__ + "static/media/avatar-2.c11a6dc6.jpg";